if (!customElements.get('table-of-contents')) {
  customElements.define(
    'table-of-contents',
    class TableOfContents extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        document.querySelectorAll('.article-template__content h2').forEach((h2, index) => {
          const li = document.createElement('li');
          h2.setAttribute('id', `heading-${index}`);
          li.innerHTML = `<a href="#heading-${index}">${h2.innerHTML}</a>`;
          this.querySelector('.art-t__table-of-contents-list').appendChild(li);
        });

        const links = this.querySelectorAll('.art-t__table-of-contents-list a');
        links.forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            console.log(event.target);
            const target = event.target.getAttribute('href') || event.target.closest('a').getAttribute('href');
            const targetElement = document.getElementById(target.replace('#', ''));
            targetElement.scrollIntoView({ behavior: 'smooth' });
          });
        });
      }
    }
  );
}
